<div class="dropdown-field-container">
  <label class="dropdown-label" *ngIf="label">
    {{ label }}<span class="required-asterisk" *ngIf="required">*</span>
  </label>
  
  <div class="dropdown-wrapper" [class.disabled]="disabled">
    <div 
      class="dropdown-trigger"
      [class.open]="isOpen"
      [class.has-value]="value"
      (click)="toggleDropdown()"
      (blur)="onBlur()"
      tabindex="0">
      <span class="dropdown-text">{{ getSelectedLabel() }}</span>
      <svg class="dropdown-arrow" 
           [class.rotated]="isOpen" 
           width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    
    <div class="dropdown-menu" *ngIf="isOpen && !disabled">
      <div class="dropdown-option" 
           *ngFor="let option of options"
           [class.selected]="option.value === value"
           (click)="selectOption(option)">
        {{ option.label }}
      </div>
    </div>
  </div>
  
  <div class="error-message" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>
</div>
